import { useHasProperty } from "@/hooks";
import { IHasPages } from "@/utils/types/component";

const HasCatalogWrapper: React.FC<IHasPages> = ({ children }) => {
  const { hideCatalog } = useHasProperty();

  if (hideCatalog) {
    return <></>;
  }

  return <>{children}</>;
};

export default HasCatalogWrapper;
